import "../styles/Dashboard.css";
import {
  useNavigate,
  Link,
  useLocation
} from "react-router-dom";

import React, { useEffect, useState } from "react";

/* ─── Icons ─── */
const RefreshIcon = ({ size = 18, color = "#fff" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 4v6h6" /><path d="M23 20v-6h-6" />
    <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15" />
  </svg>
);
const LayoutIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" /><line x1="3" y1="9" x2="21" y2="9" />
    <line x1="9" y1="21" x2="9" y2="9" />
  </svg>
);
const RepeatIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="17 1 21 5 17 9" /><path d="M3 11V9a4 4 0 0 1 4-4h14" />
    <polyline points="7 23 3 19 7 15" /><path d="M21 13v2a4 4 0 0 1-4 4H3" />
  </svg>
);
const CreditCardIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="4" width="22" height="16" rx="2" /><line x1="1" y1="10" x2="23" y2="10" />
  </svg>
);
const SettingsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);
const HelpIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);
const ZapIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
);
const CheckCircleIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);

/* ─── Data ─── */
const NAV_ITEMS = [
  { label: "Dashboard", icon: <LayoutIcon />, active: true,path: "/dashboard" },
  { label: "Conversions", icon: <RepeatIcon />, active: false,path: "/conversions" },
  { label: "Payments", icon: <CreditCardIcon />, active: false,path: "/payments" },
  { label: "Settings", icon: <SettingsIcon />, active: false,path: "/settings" },
  { label: "Help", icon: <HelpIcon />, active: false,path: "/help" },
];

/*const STAT_CARDS = [
  { label: "CURRENT PLAN", value: "Pro Plan", sub: "Auto-renewing subscription", color: "#2563EB" },
  { label: "TOTAL CONVERSIONS", value: "12,847", sub: "↑ 12% increase this month", color: "#10B981" },
  { label: "TOTAL PAYMENTS", value: "$2,340.00", sub: "All invoices processed successfully", color: "#2563EB" },
];*/

/* ─── Sidebar ─── */
function Sidebar({ user }) {
    // Inside your sidebar component:
    const navigate = useNavigate();
    const location = useLocation();
    const currentUser = JSON.parse(
          localStorage.getItem("currentUser") || "{}"
        );

    const handleLogout = () => {
      localStorage.removeItem("currentUser");
      localStorage.removeItem("selectedPlan");
      navigate("/");
    };
  return (
    <aside className="db-sidebar">
      <div className="db-sidebar-upper">
        <div className="db-profile">
          <div className="db-avatar">
          {currentUser.full_name
                        ? currentUser.full_name
                            .split(" ")
                            .map((n) => n[0])
                            .join("")
                            .substring(0, 2)
                            .toUpperCase()
                        : "U"}
          </div>
          <div className="db-profile-info">
            <span className="db-profile-name">{user?.full_name || "Guest"}</span>
            <span className="db-profile-role">{user?.email}</span>
          </div>
        </div>
        <nav className="db-nav">
          {NAV_ITEMS.map((item) => (
              <Link
                key={item.label}
                to={item.path}
                className={`db-nav-item ${
                  location.pathname === item.path
                    ? "db-nav-item--active"
                    : ""
                }`}
              >
                <span className="db-nav-icon">
                  {item.icon}
                </span>
                {item.label}
              </Link>
            ))}
            {/* ─── Logout separator + button ─── */}
                      <div className="db-nav-separator" />
                      <button className="db-nav-item db-nav-logout" onClick={handleLogout}>
                        <span className="db-nav-icon">
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#E24646" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                            <polyline points="16 17 21 12 16 7" />
                            <line x1="21" y1="12" x2="9" y2="12" />
                          </svg>
                        </span>
                        Log Out
                      </button>
        </nav>
      </div>
    </aside>
  );
}

/* ─── Main Content ─── */
function MainContent({
  user,
  conversionHistory,
  subscription,
  payments
}) {
    const totalConversions =
      conversionHistory.length;

    const totalPayments =
      payments.reduce(
        (sum, payment) =>
          sum + Number(payment.amount || 0),
        0
      );

    const currentPlan =
      subscription?.plan_id
        ? `Plan ${subscription.plan_id}`
        : "No Active Plan";

    const STAT_CARDS = [
      {
        label: "CURRENT PLAN",
        value: currentPlan,
        sub: "Active Subscription",
        color: "#2563EB"
      },
      {
        label: "TOTAL CONVERSIONS",
        value: totalConversions,
        sub: "Completed conversions",
        color: "#10B981"
      },
      {
        label: "TOTAL PAYMENTS",
        value: `₹${totalPayments}`,
        sub: "Total payments",
        color: "#2563EB"
      }
    ];
  return (
    <main className="db-main">
      {/* Welcome Banner */}
      <div className="db-welcome">
        <div className="db-welcome-text">
          <h2>Welcome back, {user?.full_name}! 👋</h2>
          <p>Your active pipelines are healthy. You've completed 1,204 high-speed conversions today alone with zero queuing latency.</p>
        </div>
        <div className="db-welcome-tag">
          <ZapIcon />
          <span>Avg. latency: 142ms</span>
        </div>
      </div>

      {/* Overview Header */}
      <div className="db-overview-header">
        <div>
          <h3 className="db-section-title">Dashboard Overview</h3>
          <p className="db-section-sub">Performance metrics for your active conversion workspace</p>
        </div>
        <button className="db-refresh-btn">
          <RefreshIcon size={14} color="#475569" />
          Refresh Live Stats
        </button>
      </div>

      {/* Stat Cards */}
      <div className="db-stats-row">
        {STAT_CARDS.map((card) => (
          <div key={card.label} className="db-stat-card">
            <div className="db-stat-header">
              <span className="db-stat-label">{card.label}</span>
              <div className="db-stat-icon" style={{ background: card.color }} />
            </div>
            <div className="db-stat-body">
              <span className="db-stat-value">{card.value}</span>
              <span className="db-stat-sub">{card.sub}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Two Column Grid */}
      <div className="db-two-col">
        {/* Subscription Details */}
        <div className="db-card">
          <div className="db-card-header">
            <h4>Subscription Details</h4>
            <p>Manage your enterprise allocation and billing terms</p>
          </div>
          <div className="db-divider" />
          <div className="db-plan-info">
            <div>
              <span className="db-label">CURRENT PLAN</span>
              <span className="db-plan-title">{subscription
                                                ? `Plan ${subscription.plan_id}`
                                                : "No Active Subscription"}</span>
            </div>
            <span className="db-status-active">{subscription?.status}
                                               </span>
          </div>
          <div className="db-renewal">
            <span className="db-label">NEXT RENEWAL DATE</span>
            <span>{subscription?.end_date
                    ? new Date(subscription.end_date)
                        .toLocaleDateString()
                    : "N/A"}
                  </span>
          </div>
          <div className="db-features">
            <span className="db-label">
              INCLUDED FEATURES
            </span>

            {subscription?.features?.length > 0 ? (

              subscription.features.map((feature) => (
                <div
                  key={feature}
                  className="db-feature-row"
                >
                  <CheckCircleIcon />
                  <span>{feature}</span>
                </div>
              ))

            ) : (

              <div className="db-feature-row">
                <span>No features available</span>
              </div>

            )}
          </div>
          <button className="db-upgrade-btn">Upgrade to Custom Enterprise</button>
        </div>

        {/* Recent Activity */}
        <div className="db-card">
          <div className="db-card-header">
            <h4>Recent Activity</h4>
            <p>Live feed of conversion events</p>
          </div>
          <div className="db-divider" />
          <div className="db-timeline">
            {conversionHistory.map((item) => (
               <div
                 key={item.id}
                 className="db-timeline-row"
               >
                 <div className="db-timeline-content">
                   <strong>
                     {item.fromFormat} → {item.toFormat}
                   </strong>

                   <p>
                     {item.fileName}
                   </p>

                   <span>
                     {item.convertedAt}
                   </span>
                 </div>
               </div>
             ))}
          </div>
        </div>
      </div>

      {/* Payment History */}
      <div className="db-card">
        <div className="db-card-header">
          <h4>Payment History</h4>
          <p>View recent enterprise invoices and statement activities</p>
        </div>
        <div className="db-table">
          <div className="db-table-head">
            <span>DATE</span><span>DESCRIPTION</span><span>AMOUNT</span><span>STATUS</span>
          </div>
          {payments.map((payment) => (
             <div
               key={payment.payment_id}
               className="db-table-row"
             >
               <span>
                 {payment.paid_at}
               </span>

               <span>
                 {payment.provider}
               </span>

               <span>
                 ₹{payment.amount}
               </span>

               <span>
                 {payment.status}
               </span>
             </div>
           ))}
        </div>
      </div>
    </main>
  );
}

/* ─── Dashboard Page ─── */
export default function ConvertProDashboard() {
    const API_URL = process.env.REACT_APP_API_URL;

    const [user, setUser] = useState(null);
    const [conversionHistory, setConversionHistory] = useState([]);
    const [subscription, setSubscription] = useState(null);
    const [payments, setPayments] = useState([]);

    const loadDashboardData = React.useCallback(
            async (userId) => {
          try {

            const [
              historyRes,
              subscriptionRes,
              paymentsRes
            ] = await Promise.all([
              fetch(`${API_URL}/history/${userId}`),
              fetch(`${API_URL}/subscription/${userId}`),
              fetch(`${API_URL}/payments/${userId}`)
            ]);

            const historyData =
              await historyRes.json();

            const subscriptionData =
              await subscriptionRes.json();

            const paymentsData =
              await paymentsRes.json();


            setConversionHistory(historyData || []);
            setSubscription(subscriptionData);
            setPayments(paymentsData || []);

          } catch (err) {

            console.error(
              "Dashboard load error",
              err
            );

          } finally {

          }
        }
        , [API_URL]
    );

    useEffect(() => {
      const currentUser = JSON.parse(
        localStorage.getItem("currentUser") || "null"
      );

      if (!currentUser) return;

      setUser(currentUser);

      loadDashboardData(currentUser.user_id);
    }, [loadDashboardData]);

  return (
    <div className="db-layout">
      <Sidebar user={user} />
      <MainContent
        user={user}
        conversionHistory={conversionHistory}
        subscription={subscription}
        payments={payments}
      />
    </div>
  );
}